const SCREENING_DETAILS_NAME_ROUTE = `screenings-id`
const isScreeningDetailsNameRoute = (name) => name === SCREENING_DETAILS_NAME_ROUTE
export default function ({ store, route, redirect }) {
  const userAsClient =
    store.getters[`permissions/userIsClient`] && !store.$auth?.user.candidate_screenings.includes(route.params.id)
  userAsClient && isScreeningDetailsNameRoute(route?.name) && redirect(`/client`, { screening: route.params.id })
}
